const directiveName = 'ltFloatLabels';
const directive = [() => {
	return {
		restrict: 'A',
		require: '?ngModel',
		priority: -10000,
		link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes, ctrl: ng.INgModelController) => {
			if (!ctrl) {
				return;
			}

			const unwatch = scope.$watch(element.val(), (oldValue: string, newValue: string) => {
				if (newValue) {
					$(element).trigger('checkval');
					unwatch();
				}
			});
		}
	} as ng.IDirective<ng.IScope, ng.IAugmentedJQuery, ng.IAttributes, ng.INgModelController>;
}];

export default function(module: ng.IModule): void {
	module.directive(directiveName, directive);
}
